import { ScreenSize } from 'glints-aries';
import styled from 'styled-components';

export const LoginNudgeViewContainer = styled.div`
  background: linear-gradient(0deg, #ffffff 0%, #c3e8ff 100%);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  gap: 16px;
  margin-top: -15px;
  margin-bottom: 30px;
  border-radius: 8px;

  @media (min-width: ${ScreenSize.tablet}px) {
    margin-top: 0;
    border-radius: 12px;
  }
`;

export const Caption = styled.p`
  font-size: 14px;
  line-height: 21px;
  text-align: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
